module.exports = __webpack_public_path__ + "pc/img/swiper_02.136fc613.png";